<template>
  <div
    class="notice-container"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave">
    <transition-group name="notice-transition" tag="div" class="notice-wrapper">
      <div class="notice-item" :key="currentNotice.id">
        <div style="display: flex; align-items: center; flex: 1">
          <img
            src="@/assets/image/消息.png"
            style="width: 60px; height: 60px; margin-right: 20px" />
          {{ currentNotice.title }}
        </div>
        <div class="notice-time">
          {{ timeFormat(currentNotice.publishDate) }}
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "RollingNotice",

  props: {
    notices: {
      type: Array,
      required: true,
      default: () => [],
    },
    speed: {
      type: Number,
      default: 3000,
    },
    pauseOnHover: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      currentIndex: 0,
      timer: null,
      isPaused: false,
    };
  },

  computed: {
    currentNotice() {
      return this.notices[this.currentIndex] || { id: 0, title: "" };
    },
  },

  methods: {
    // 时间格式化
    timeFormat(time) {
      return time.substring(0, 10);
    },
    startTimer() {
      this.timer = setInterval(() => {
        if (!this.isPaused) {
          this.currentIndex = (this.currentIndex + 1) % this.notices.length;
        }
      }, this.speed);
    },

    handleMouseEnter() {
      if (this.pauseOnHover) {
        this.isPaused = true;
      }
    },

    handleMouseLeave() {
      if (this.pauseOnHover) {
        this.isPaused = false;
      }
    },
  },

  mounted() {
    if (this.notices.length > 1) {
      this.startTimer();
    }
  },

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  watch: {
    notices: {
      handler(newVal) {
        if (newVal.length > 1) {
          if (this.timer) clearInterval(this.timer);
          this.startTimer();
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.notice-container {
  width: 100%;
  margin: 0 auto;
  height: 68px;
  font-size: 20px;
  margin-bottom: 20px;
  overflow: hidden;
  position: relative;
  color: #4a4a4a;
}

.notice-wrapper {
  height: 100%;
  position: relative;
}

.notice-item {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.notice-time {
  font-weight: normal;
  font-size: 20px;
  color: #9b9b9b;
  line-height: 28px;
  text-align: center;
  font-style: normal;
}
/* 过渡动画 */
.notice-transition-enter-active,
.notice-transition-leave-active {
  transition: all 0.5s ease;
}

.notice-transition-enter {
  transform: translateY(100%);
}

.notice-transition-leave-to {
  transform: translateY(-100%);
}
</style>
